import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const AnimationContainer = styled.div`
    @keyframes fadeTooltip {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    animation: fadeTooltip 100ms ease-in;
`;

const Container = styled(AnimationContainer)`
    position: absolute;
    border-radius: 2px;
    background-color: ${(props) => props.theme.colors['surface-grey-800']};
    padding: 6px 8px;
    z-index: 5;

    font-size: 12px;
    letter-spacing: 0.32px;
    line-height: 16px;
    color: white;
    cursor: initial;
`;

const Arrow = styled(AnimationContainer)`
    position: absolute;
    z-index: 5;
    border-width: 5px;
    border-style: solid;
`;

const BottomTooltipArrow = styled(Arrow)`
    left: 50%;
    transform: translateX(-50%);
    top: calc(100% - 2px);
    border-color: transparent transparent ${(props) => props.theme.colors['surface-grey-800']} transparent;
`;

const TopTooltipArrow = styled(Arrow)`
    left: 50%;
    transform: translateX(-50%);
    bottom: calc(100% - 2px);
    border-color: ${(props) => props.theme.colors['surface-grey-800']} transparent transparent transparent;
`;

const BottomTooltip = styled(Container)`
    top: calc(100% + 8px); /** Altezza del tooltip più altezza della freccia e uno spazio */
    left: 50%;
    transform: translateX(-50%);
`;

const TopTooltip = styled(Container)`
    bottom: calc(100% + 8px); /** Altezza del tooltip più altezza della freccia e uno spazio */
    left: 50%;
    transform: translateX(-50%);
`;

const RightTooltip = styled(Container)`
    left: calc(100% + 8px); /** Larghezza tooltip più la freccia e uno spazio */
`;

const LeftTooltip = styled(Container)`
    right: calc(100% + 8px); /** Larghezza tooltip più la freccia e uno spazio */
`;

const RightTooltipArrow = styled(Arrow)`
    top: 50%;
    transform: translateY(-50%);
    left: calc(100% - 2px);
    border-color: transparent ${(props) => props.theme.colors['surface-grey-800']} transparent transparent;
`;

const LeftTooltipArrow = styled(Arrow)`
    top: 50%;
    transform: translateY(-50%);
    right: calc(100% - 2px);
    border-color: transparent transparent transparent ${(props) => props.theme.colors['surface-grey-800']};
`;

const createSpecificTooltip = (pos) => {
    if (pos === 'top') {
        return TopTooltip;
    }

    if (pos === 'right') {
        return RightTooltip;
    }

    if (pos === 'left') {
        return LeftTooltip;
    }

    return BottomTooltip;
};

const createSpecificArrow = (pos) => {
    if (pos === 'top') {
        return TopTooltipArrow;
    }

    if (pos === 'right') {
        return RightTooltipArrow;
    }

    if (pos === 'left') {
        return LeftTooltipArrow;
    }

    return BottomTooltipArrow;
};

const GeneralTooltip = ({ children, position = 'bottom' }) => {
    const ref = useCallback((node) => {
        if (node) {
            const width = document.body.clientWidth;

            const l = node.getBoundingClientRect().left;
            const r = node.getBoundingClientRect().right;

            if (r > width) {
                node.style.left = `-${r - width - 16}px`;
            }

            if (l < 0) {
                node.style.left = `${-l + 16}px`;
            }
        }
    }, []);

    const SpecificArrow = createSpecificArrow(position);
    const SpecificTooltip = createSpecificTooltip(position);

    return (
        <>
            <SpecificArrow />
            <SpecificTooltip ref={ref}>{children}</SpecificTooltip>
        </>
    );
};

GeneralTooltip.propTypes = {
    children: PropTypes.node,
    position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
};

export default GeneralTooltip;
